/** Shared language/currency for Intl formatters (updated by I18n + Units providers). */
let language = 'en';
let currency = 'USD';

export function setFormatPrefs({ language: lang, currency: curr } = {}) {
  if (lang && (lang === 'en' || lang === 'es')) language = lang;
  if (curr) currency = curr;
}

export function getFormatPrefs() {
  return { language, currency };
}

export const DEFAULT_FORMAT_PREFS = { language: 'en', currency: 'USD' };
